import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './item1.module.scss';
import { Item11111Type } from '@/types/faq.types';

const Item1: NextPage<Item11111Type> = ({ className = '', title, text }) => {
  return (
    <div className={[styles.item1, className].join(' ')}>
      <div className={styles.icontext}>
        <Image
          className={styles.icon}
          loading="lazy"
          width={48}
          height={48}
          sizes="100vw"
          alt=""
          src="/img/FAQ/img-faq.webp"
        />
        <h3
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        ></h3>
      </div>
      <div
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default Item1;
